import './styles.scss';
import { isMobile } from 'react-device-detect';
import cx from 'classnames';

const Footer = () => {
  return (
    <>
      <div className={cx('contacts-block', { isMobile })}>
        <div className="contacts-top-wrapper">
          <div className="home-logo">
            <img src="/images/logo.svg" alt="AllCareForms" />
          </div>
          <div className="contacts-card">
            <p className="contacts-title">Contacts</p>
            <div className="contacts-card-divider"></div>
            <div className="contacts-card-phone">
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2362_4040)">
                  <path
                    d="M14.2957 5.43107C15.1911 5.60576 16.0139 6.04364 16.659 6.68868C17.304 7.33372 17.7419 8.15656 17.9166 9.0519M14.2957 1.7644C16.1559 1.97105 17.8905 2.80406 19.2148 4.12666C20.539 5.44926 21.3742 7.18283 21.5832 9.04274M20.6666 16.3577V19.1077C20.6676 19.363 20.6153 19.6157 20.513 19.8496C20.4108 20.0836 20.2608 20.2935 20.0726 20.4661C19.8845 20.6387 19.6624 20.7701 19.4206 20.8519C19.1787 20.9337 18.9225 20.9641 18.6682 20.9411C15.8475 20.6346 13.138 19.6707 10.7574 18.1269C8.54257 16.7195 6.66479 14.8417 5.2574 12.6269C3.70821 10.2355 2.74412 7.51282 2.44323 4.6794C2.42032 4.42592 2.45045 4.17043 2.53169 3.92923C2.61293 3.68802 2.7435 3.46637 2.9151 3.27839C3.0867 3.09041 3.29555 2.94022 3.52837 2.83738C3.76119 2.73454 4.01288 2.68131 4.2674 2.68107H7.0174C7.46226 2.67669 7.89354 2.83423 8.23085 3.12431C8.56815 3.41439 8.78847 3.81723 8.85073 4.25774C8.9668 5.1378 9.18206 6.0019 9.4924 6.83357C9.61573 7.16167 9.64242 7.51824 9.56931 7.86104C9.4962 8.20385 9.32636 8.51851 9.0799 8.76774L7.91573 9.9319C9.22066 12.2268 11.1208 14.127 13.4157 15.4319L14.5799 14.2677C14.8291 14.0213 15.1438 13.8514 15.4866 13.7783C15.8294 13.7052 16.186 13.7319 16.5141 13.8552C17.3457 14.1656 18.2098 14.3808 19.0899 14.4969C19.5352 14.5597 19.9419 14.784 20.2326 15.1271C20.5233 15.4702 20.6777 15.9082 20.6666 16.3577Z"
                    stroke="#040E46"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2362_4040">
                    <rect width="22" height="22" fill="white" transform="translate(0.5 0.847656)" />
                  </clipPath>
                </defs>
              </svg>{' '}
              <a href="tel:724-705-2198">(724)705-2198</a>
            </div>
            <div className="contacts-card-email">
              <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.66659 4.5144H18.3333C19.3416 4.5144 20.1666 5.3394 20.1666 6.34774V17.3477C20.1666 18.3561 19.3416 19.1811 18.3333 19.1811H3.66659C2.65825 19.1811 1.83325 18.3561 1.83325 17.3477V6.34774C1.83325 5.3394 2.65825 4.5144 3.66659 4.5144Z"
                  stroke="#040E46"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M20.1666 6.34766L10.9999 12.7643L1.83325 6.34766"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>{' '}
              <a href="mailto:info@allcareforms.com">info@allcareforms.com</a>
            </div>
          </div>
        </div>
        <div className="contacts-divider"></div>
        <div className="contacts-footer">
          <div className="rights-reserved">© 2025 AllCareForms. All rights reserved.</div>
          <div className="footer-links">
            <div>Privacy Policy</div>
            <div>Terms of Service</div>
            <div className="cookies-settings-link">Cookies Settings</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
